import { Link } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import BVNModal from './BVNModal.js';
import CACModal from './CACModal.js';

import CheckSymplus from '../utils/AccountChecks.js';

const Hero = () => {
    const [individualEmail, setIndividualEmail] = useState("")
    const [individualEmailOtp, setIndividualEmailOtp] = useState("")

    // PENDING STATES
    const [emailCheckPending, setEmailCheckPending] = useState(false)
    const [verifiedEmail, setVerifiedEmail] = useState("")
    const [verificationStatus, setVerificationStatus] = useState("")
    const [accountDetail, setAccountDetail] = useState([])

    // VARIABLES FOR EMAIL OTP
    const [newEmail, setNewEmail] = useState("")
    const [emailOtpPending, setEmailOtpPending] = useState("")
    const [emailOtpStatus, setEmailOtpStatus] = useState("")



    const base_url = process.env.REACT_APP_BASE_URL;
    const navigate = useNavigate()

    const handleIndividualEmail = (event) => {
        setEmailCheckPending(true);
        event.preventDefault();

        const iEmailPayload = {
            "email": individualEmail
        };

        axios.post(`${base_url}/onboarding/search-user`, iEmailPayload)
            .then((response) => {
                console.log("Response from email check:", response.data);
                if (response.data.length === 0) {
                    toast.warning("No Account was found for this email address", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    setVerificationStatus("failed")
                } else {
                    toast.success("An account was Found with your email.", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    setVerifiedEmail(individualEmail)
                    setVerificationStatus("passed")
                    setAccountDetail(response.data)
                    console.log(response.data)
                    // setTimeout(() => { navigate("/products") }, 3000)
                }

            })
            .catch((error) => {
                console.log(error);
                toast.error("Sorry, a network error occurred and your request was not completed", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            })
            .finally(() => {
                setEmailCheckPending(false)
            })

    };

    const sendEmailOtp = () => {
        axios.post("http://10.10.10.46:4242/otp/create-email-otp",
            { "email": newEmail }
        )
            .then((response) => {
                console.log(response.data)
                setEmailOtpStatus("sent")
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const verifyEmailOtp = () => {

    }

    return (
        <>
            <div className="">
                <ToastContainer />
                <section className="">
                    <div className="container">
                        <div className="row pb-5">
                            <div className="col-xs-12 col-md-12 col-lg-7">
                                <div className="pt-5 px-3">
                                    <h1 className="bold hero-big" style={{ color: '#414142', maxWidth: "" }}>Grow your wealth with the Masters.</h1>
                                    <div className='paragraph'>
                                    <p style={{ color: '#414142', marginBottom: "7px" }} className='hero-small'>
                                        With our range of innovative financial solutions, you can make your money work for you. Norrenberger provides services across asset management, private equity, development finance, investment banking, securities trading, pensions, insurance, fintech and digital banking.
                                    </p>
                                    <p style={{ color: '#414142' }} className='hero-small'>
                                        Ready to take control of your finances?
                                    </p>
                                    </div>
                                </div>
                                <div className="container mt-2">
                                    <div className="row" style={{marginLeft: "-1.2rem"}}>
                                        <div className="col-12 my-2 col-lg-7">
                                            <h5 className="bold get-started" style={{ marginBottom: "4px", color: "#F53900" }}>Get Started</h5>
                                            <small className="hero-small" style={{ color: '#414142' }}>Select an account type <i class="bi bi-arrow-right-circle arrow"></i></small>
                                        </div>
                                        <div className="banner-link">
                                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                <div className="btn btn-fancy py-5 my-1" data-bs-toggle="modal" data-bs-target="#individual">
                                                    <h3><i id="icon" className="bi-person-circle home-icon"></i></h3>
                                                    <h5 className="normal text-big" style={{ marginBottom: "0px" }}>Individual</h5>
                                                    <small className="hero-text">Open an individual account</small>
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                <div className="btn btn-fancy py-5 my-1" data-bs-toggle="modal" data-bs-target="#corporate">
                                                    <h3><i id="icon" className="bi-buildings home-icon"></i></h3>
                                                    <h5 className="normal text-big" style={{ marginBottom: "0px" }}>Corporate</h5>
                                                    <small className="hero-text">Open a business account</small>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div className="col-xs-12 col-md-6 col-lg-5"></div>
                        </div>
                    </div>
                </section>


                {/* MODAL DATA CONTENT =============================================================================================================================== */}

                {/* INDIVIDUAL MODALS */}
                <div>
                    <div className="modal fade" id="individual">
                        <div className="modal-dialog modal-sm">
                            <div className="modal-content radius-3">

                                {/* <!-- Modal Header --> */}
                                <div className="modal-header">
                                    <h6 className="modal-title "> Account Status</h6>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                                </div>

                                {/* <!-- Modal body --> */}
                                <div className="modal-body">
                                    <div className="container-fluid">
                                        <div className="text-center">
                                            <h2><i className="bi bi-person-bounding-box text-muted" ></i></h2>
                                            <h6 style={{ fontSize: '11px', color: 'grey' }}>Are you a new or existing user</h6>
                                            <div className='text-center'>
                                                {/* <button className="btn-custom m-1" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#bvn-verification" style={{ fontSize: "10px" }} >New User</button> */}
                                                <Link to="/new-individual-account">
                                                    <button className="btn-custom m-1" data-bs-dismiss="modal" style={{ fontSize: "10px" }} >New User</button>
                                                </Link>
                                                <button className="btn-custom-outline m-1" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#individual-verification" style={{ fontSize: "10px" }}>Existing User</button>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* EMAIL VERIFICATION INDIVIDUAL*/}
                    <div className="modal fade" id="individual-verification">
                        <div className="modal-dialog modal-sm">
                            <div className="modal-content ">

                                {/* <!-- Modal Header --> */}
                                <div className="modal-header">
                                    <h6 className="modal-title bold"><i className="bi bi-person-circle me-1"></i> Account Verification</h6>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={() => { setVerificationStatus("") }}></button>
                                </div>

                                {/* <!-- Modal body --> */}
                                <div className="modal-body">
                                    <div className="container-fluid">

                                        {
                                            emailCheckPending ? (
                                                <>
                                                    <div className="text-center">
                                                        <div class="spinner-border spinner-border text-custom"></div>
                                                        <p>Verifying your Email</p>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    {
                                                        verificationStatus === "passed" ? (
                                                            <>
                                                                <div className="text-center">
                                                                    <h3 style={{ marginBottom: "-10px" }}><i className="bi-person text-muted"></i></h3>
                                                                    <small className="text-small bold text-muted">Account Verified <i className="bi-check-circle-fill text-success"></i></small>
                                                                    <p className="p-1 text-small bold">{accountDetail[0].CUSTOMER_NAME || "<small style={{fontSize:'10px'}}>Loading customer data</small>"}</p>
                                                                    {/* <p>{accountDetail[0].CUSTOMER_NAME || "<small style={{fontSize:'10px'}}>Loading customer data</small>"}</p> */}
                                                                    <button className="btn-custom" data-bs-dismiss="modal" onClick={() => {
                                                                        setVerificationStatus("")
                                                                        navigate("/products")
                                                                    }}>Continue to Products<i className='bi-chevron-right ms-2'></i></button>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <form onSubmit={handleIndividualEmail} enctype="multipart/form-data">
                                                                <div className="row">
                                                                    <div className="">
                                                                        <label for="email" className="small bold">Enter your Registered Email</label>
                                                                        <input type="email" className="form-control custom-input" value={individualEmail} onChange={(e) => setIndividualEmail(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                                <button className="btn-custom w-100 my-3" type="submit" >Continue <i className="bi bi-arrow-right mt-1"></i></button>
                                                            </form>
                                                        )
                                                    }

                                                </>
                                            )
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {/* End individual Modals ===================================== ======================================= ==================================================================================== */}

                {/* CORPORATE MODALS */}
                <div className="modal fade" id="corporate">
                    <div className="modal-dialog modal-sm">
                        <div className="modal-content radius-3">

                            {/* <!-- Modal Header --> */}
                            <div className="modal-header">
                                <h6 className="modal-title"><i className="bi bi-person me-2"></i> Account Status</h6>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>

                            {/* <!-- Modal body --> */}
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="text-center">
                                        <h2><i className="bi bi-buildings text-muted" ></i></h2>
                                        <h6 style={{ fontSize: '11px', color: 'grey' }}>Do you have an Account?</h6>
                                        <div className='text-center'>
                                            {/* <button className="btn-custom m-1" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#bvn-verification"  style={{ fontSize: "10px" }} >New User</button> */}
                                            <Link to="/new-corporate-account">
                                                <button className="btn-custom m-1" data-bs-dismiss="modal" style={{ fontSize: "10px" }} >New User</button>
                                            </Link>
                                            <button className="btn-custom-outline m-1" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#corporate-verification" style={{ fontSize: "10px" }}>Existing User</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* EMAIL VERIFICATION CORPORATE*/}
                <div className="modal fade" id="corporate-verification">
                    <div className="modal-dialog modal-sm">
                        <div className="modal-content ">

                            {/* <!-- Modal Header --> */}
                            <div className="modal-header">
                                <h6 className="modal-title bold"><i className="bi bi-person me-2"></i> Email Verification</h6>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={() => { setVerificationStatus("") }}></button>
                            </div>

                            {/* <!-- Modal body --> */}
                            <div className="modal-body">
                                <div className="container-fluid">
                                    {
                                        emailCheckPending ? (
                                            <>
                                                <div className="text-center">
                                                    <div class="spinner-border spinner-border text-custom"></div>
                                                    <p>Verifying your Email</p>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                {
                                                    verificationStatus === "passed" ? (
                                                        <>
                                                            <div className="text-center">
                                                                <h3 style={{ marginBottom: "-10px" }}><i className="bi-person text-muted"></i></h3>
                                                                <small className="text-small bold text-muted">Account Verified <i className="bi-check-circle-fill text-success"></i></small>
                                                                <p className="p-1 text-small bold">{accountDetail[0].CUSTOMER_NAME || "<small style={{fontSize:'10px'}}>Loading customer data</small>"}</p>
                                                                {/* <p>{accountDetail[0].CUSTOMER_NAME || "<small style={{fontSize:'10px'}}>Loading customer data</small>"}</p> */}
                                                                <button className="btn-custom" data-bs-dismiss="modal" onClick={() => {
                                                                    setVerificationStatus("")
                                                                    navigate("/products")
                                                                }}>Continue to Products<i className='bi-chevron-right ms-2'></i></button>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <form onSubmit={handleIndividualEmail} enctype="multipart/form-data">
                                                            <div className="row">
                                                                <div className="">
                                                                    <label for="email" className="small bold">Enter your Registered Email</label>
                                                                    <input type="email" className="form-control custom-input" value={individualEmail} onChange={(e) => setIndividualEmail(e.target.value)} />
                                                                </div>
                                                            </div>
                                                            <button className="btn-custom w-100 my-3" type="submit" >Continue <i className="bi bi-arrow-right mt-1"></i></button>
                                                        </form>
                                                    )
                                                }

                                            </>
                                        )
                                    }

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* NEW USER EMAIL ACCOUNT CHECKS*/}
                <div className="modal fade" id="account-check">
                    <div className="modal-dialog modal-sm">
                        <div className="modal-content ">

                            {/* <!-- Modal Header --> */}
                            <div className="modal-header">
                                <h6 className="modal-title bold"><i className="bi bi-person me-2"></i> Get Started</h6>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>

                            {/* <!-- Modal body --> */}
                            <div className="modal-body">
                                <div className="container-fluid">
                                    {
                                        emailOtpPending ? (
                                            <>
                                                <div className="text-center">
                                                    <div class="spinner-border spinner-border text-custom"></div>
                                                    <p>Sending A verification</p>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                {
                                                    emailOtpStatus === "sent" ? (
                                                        <>
                                                            <form onSubmit={verifyEmailOtp} enctype="multipart/form-data">
                                                                <div className="row">
                                                                    <div className="">
                                                                        <label for="email" className="small bold">Enter Verification Code</label>
                                                                        <input type="email" className="form-control custom-input" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                                <button className="btn-custom w-100 my-3" type="submit" >Continue <i className="bi bi-arrow-right mt-1"></i></button>
                                                            </form>
                                                        </>
                                                    ) : (
                                                        <form onSubmit={sendEmailOtp} enctype="multipart/form-data">
                                                            <div className="row">
                                                                <div className="">
                                                                    <label for="email" className="small bold">Enter your Email</label>
                                                                    <input type="email" className="form-control custom-input" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} />
                                                                </div>
                                                            </div>
                                                            <button className="btn-custom w-100 my-3" type="submit" >Continue <i className="bi bi-arrow-right mt-1"></i></button>
                                                        </form>
                                                    )
                                                }

                                            </>
                                        )
                                    }

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* End JSX */}

            </div>

            <BVNModal />
            <CACModal />
        </>


    )
}

export default Hero;